import React from 'react';
import InputBase from '@mui/material/InputBase';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'store';
import AppSearchResults from 'Layout/AppSearchResults';
import appSearchSx from './AppSearch.styles';
import { useTheme } from '@mui/material/styles';
import { IconButton, InputAdornment, Tooltip, Box } from '@mui/material';
import { Code, Search as SearchIcon } from '@mui/icons-material';

const AppSearch = () => {
    let anchor = React.createRef();
    const theme = useTheme();
    const sx = appSearchSx(theme);
    const classes = sx,
        dispatch = useDispatch(),
        appSearchTerm = useSelector((state) => state.layout.appSearchTerm),
        setSearchTerm = (e) => dispatch(actions.layout.setSearchTerm(e));

    return (
        <React.Fragment>
            <Box sx={sx.search} ref={anchor}>
                <Box sx={sx.searchIcon}>
                    <SearchIcon />
                </Box>
                <InputBase
                    placeholder="Sabertooth Search"
                    value={appSearchTerm}
                    onChange={setSearchTerm}
                    sx={{
                        ...sx.inputRoot,
                        '& .MuiInputBase-input': sx.inputInput,
                    }}
                    endAdornment={
                        <InputAdornment position="end">
                            <Tooltip title="Advanced Search">
                                <IconButton aria-label="Advanced Search" size="large">
                                    <Code />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    }
                />
            </Box>
            <AppSearchResults anchor={anchor} />
        </React.Fragment>
    );
};

export default AppSearch;
